import type { AuditResult, CriteriaItem } from '@/content-review/api'
import { isCriterionForSubjects } from '@/content-review/utils/criteria'

export type GoalReviewSection = 'goals' | 'objectives'

export interface GoalReviewAudience {
  grades: string[]
  subjects: string[]
}

function isCriterionForGrades(criterion: CriteriaItem, grades: string[]): boolean {
  if (!criterion.grades || criterion.grades.length === 0) return true
  return criterion.grades.some((grade) => grades.includes(grade))
}

export function isCriterionForGoal(criterion: CriteriaItem, { grades, subjects }: GoalReviewAudience): boolean {
  return isCriterionForGrades(criterion, grades) || isCriterionForSubjects(criterion, subjects)
}

const UNLISTED_CRITERION_ORDER = Number.MAX_SAFE_INTEGER

export function sortByCriteriaOrder(results: AuditResult[], criteria: CriteriaItem[]): AuditResult[] {
  const criteriaOrder = (result: AuditResult) => {
    const index = criteria.findIndex((criterion) => criterion.label === result.audit_title)
    return index === -1 ? UNLISTED_CRITERION_ORDER : index
  }
  return [...results].sort((a, b) => criteriaOrder(a) - criteriaOrder(b))
}

export function resultsForSection(results: AuditResult[], section: GoalReviewSection): AuditResult[] {
  return results.filter((result) => result.section === section)
}
